<template>
  <span>
    <b-tooltip :target="target" :title="title"/>
    <font-awesome-icon :id="target" icon="question-circle" class="icon ml-1" size="sm"/>
  </span>
</template>

<script>
  export default {
    name: "FieldTitleHint",
    props: {
      target: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
    }
  }
</script>

<style scoped>

</style>